import React, { useState } from 'react';
function BMRTable({ formula,bmr, Sedentary, Exercise1_3, Exercise4_5, DailyExercise, IntenseExercise, VeryIntenseExercise}) {
  return (
    <table >
      <thead>
        <tr>
          <th >إجمالي الاحتياجات اليومية من السعرات الحرارية:</th>
          <th > السعرات الحرارية (يومياً)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>الجلوس (قليل أو لا تمارين)</td>
          <td>{Sedentary} </td>
        </tr>
        <tr >
          <td>تمارين /رياضة 1-3 أيام في الأسبوع </td>
          <td>{Exercise1_3} </td>
        </tr>
        <tr >
          <td>تمارين /رياضة 4-5 أيام في الأسبوع</td>
          <td>{Exercise4_5} </td>
        </tr>
        <tr >
        <td>
تمرين يومي أو تمرين مكثف 3-4 مرات / أسبوع
          </td>
          <td>{DailyExercise} </td>
        </tr>
        <tr >
          <td>تمارين شاقة/رياضة 6-7 أيام في الأسبوع</td>
          <td>{IntenseExercise} </td>
        </tr>
        <tr >
          <td>
          تمرين مكثف للغاية يوميًا ، أو عملًا بدنيًا
          </td>
          <td>{VeryIntenseExercise} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMRTable;
